import React, { useMemo } from 'react';
import { sortMembersBySortOrderFirst } from '../../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { Operation } from '../../OperationsList/Operation';

interface ClientEventsListProps {
  prefix: string;
  node: any;
}

export function ClientEventsList({ node, prefix }: ClientEventsListProps) {
  const sortedNodeClientEvents = useMemo(() => {
    return sortMembersBySortOrderFirst(node?.data?.clientEvents || []) || [];
  }, [node]);

  return (
    <>
      {sortedNodeClientEvents.map((clientEvent, i) => (
        <Operation
          prefix={prefix}
          key={`OPERATION__${clientEvent.urlFormat}__${node.data.urlFormat}_${i}`}
          node={node}
          operation={clientEvent}
        />
      ))}
    </>
  );
}
